<div class="voting-tabs">
  <div class="vote-time-info" *ngIf="stopedClicked">
      <img src="./assets/images/icons/time-icon.svg" alt="">
     {{ 'meetings.Votingwasavailablefor' | translate }}<span>{{availableTime}}</span>  {{ 'meetings.minutes' | translate }}
  </div>
  <div class="primary-tabs">
      <div class="tabs-nav">
          <label *ngFor='let tab of tabs'
              (click)='currentTabVal = tab.value'
              [hidden]='item.votingModel.votingSchemaType == 0 && tab.value == 1'
              [class.active]='currentTabVal == tab.value'>{{tab.label}}</label>
      </div>
  </div>

  <div class="tabs-container tabs-section">
      <div class="attendees-answers" *ngIf="currentTabVal == 0">
          <h5 class="title">{{item.votingModel.title}}</h5>
          <div class="message-comments-container" *ngIf="votingResult && votingResult.votingList.length">
              <div class="comments-list">
                  <div class="comment-panel" *ngFor="let vote of votingResult.votingList; index as i;">
                      <div class="reply-header d-sm-flex justify-content-between align-items-center">
                          <div class="name-with-image small mb-3 mb-sm-0">
                              <div class="image-circle" [title]="vote.creator.creatorName">
                                  <img *ngIf="vote.creator.creatorProfilePicture"
                                          [src]="vote.creator.creatorProfilePicture"
                                          (error)="vote.creator.creatorProfilePicture = ''" />
                                  <span
                                      *ngIf="!vote.creator.creatorProfilePicture">{{ vote.creator.creatorName | shortName }}</span>
                              </div>
                              <div class="name">
                                  <h5>{{vote.creator.creatorName}}</h5>
                              </div>
                              <div class="delegated-user" *ngIf="vote.delegator && vote.delegator.creatorId">
                                  <img class="delegated-arrow" src="./assets/images/icons/arrow-delegate-icon.svg" >
                                  <div class="image-circle" [title]="vote.delegator.creatorName">
                                      <img *ngIf="vote.delegator.creatorProfilePicture"
                                              [src]="vote.delegator.creatorProfilePicture"
                                              (error)="vote.delegator.creatorProfilePicture = ''" />
                                      <span
                                          *ngIf="!vote.delegator.creatorProfilePicture">{{ vote.delegator.creatorName | shortName }}</span>
                                  </div>
                                  <div class="creatorName">
                                    ({{vote.delegator.creatorName}})
                                  </div>
                              </div>
                          </div>

                          <div class="text-lg-right">
                              <p class="time-from">{{vote.created | timeAgo}}</p>
                          </div>
                      </div>
                      <div class="reply-content" [ngClass]="{'has-delegator': vote.delegator && vote.delegator.creatorId}">
                          <div class="reply-body pt-2 pl-4">
                              <pre>{{vote.title}}</pre>
                          </div>
                      </div>
                  </div>
              </div>
          </div>
          <div class="no-document pt-0" *ngIf="!votingResult || !votingResult.votingList.length">
              <img src="./assets/images/icons/no-comments.svg" alt="">
              <p> {{ 'meetings.Noanswersyet' | translate }}!</p>
          </div>
      </div>


      <div class="summary" *ngIf="currentTabVal == 1">
          <ng-container *ngIf='votingResult && votingResult.votingSummaryList.length'>
              <h5 class="title">{{item.votingModel.title}}</h5>

              <ul class="summery-progress">
                  <li *ngFor='let answer of votingResult.votingSummaryList'>
                      <div class="sum-info">
                          <span>{{answer.title}}</span>
                          <div class="stat">
                              <span class="perc">{{answer.percentage | number:'1.0-2'}}%</span>
                              <span>({{answer.votesNumber}} <span *ngIf="answer.votesNumber != 1"> {{ 'meetings.votes' | translate }}</span><span *ngIf="answer.votesNumber == 1">
                                {{ 'meetings.avote' | translate }}</span> )</span>
                          </div>
                      </div>
                      <mat-progress-bar mode="determinate" [value]="answer.percentage"></mat-progress-bar>
                  </li>
              </ul>
          </ng-container>

          <div class="no-document pt-0" *ngIf="!votingResult || !votingResult.votingSummaryList.length">
              <img src="./assets/images/icons/no-comments.svg" alt="">
              <p> {{ 'meetings.Nosummaryyet' | translate }}!</p>
          </div>
      </div>

      <!-- <div class="recommendations" *ngIf="currentTabVal == 2">
          <h4 class="main-title">My Recommendations</h4>

          <div class="items-list-container active">
              <div *ngIf='recommendsLoader' class="dataLoading">
                  <mat-spinner class="m-auto" diameter="50"></mat-spinner>
              </div>
              <div class="items-list" *ngIf='!recommendsLoader'>
                  <div cdkDropList (cdkDropListDropped)="drop($event)">
                      <div *ngFor="let item of terms; index as i;"
                          class="terms-control" cdkDrag
                          [ngClass]='{"loading black": recommendsDeleteId == item.recommendationId}'>
                          <span class="drag-me" cdkDragHandle>
                              <svg width="6" height="10.001" viewBox="0 0 6 10.001">
                                  <path id="drag-drop-icon"
                                      d="M4884.5,8787a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm4-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm4-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Z"
                                      transform="translate(-4880 -8777)" fill="#aaa" />
                              </svg>
                          </span>
                          <span class="list-icon">
                              <svg width="14" height="14" viewBox="0 0 14 14">
                                  <path id="listing-icon"
                                      d="M3.809,6l-.33.329a.46.46,0,0,0,0,.651l2.5,2.5a.461.461,0,0,0,.651,0L12.99,3.125a.46.46,0,0,0,0-.651l-.33-.329a.461.461,0,0,0-.651,0L6.633,7.515a.461.461,0,0,1-.651,0L4.46,6A.461.461,0,0,0,3.809,6Zm9.248,1a.46.46,0,0,0-.459.425A5.606,5.606,0,1,1,7.008,1.4a5.524,5.524,0,0,1,1.3.146.462.462,0,0,0,.433-.122l.388-.388A.46.46,0,0,0,8.912.265,7.643,7.643,0,0,0,7.008,0,7,7,0,1,0,14,7.5a.461.461,0,0,0-.459-.5Z" fill="#aaa" />
                              </svg>
                          </span>
                          <div>
                              <textarea disabled placeholder="Add a recommendation..." class="form-control"
                                  [(ngModel)]="item.title"
                                  (keyup)="textAreaAdjust($event); updateListItem(i, $event)"
                                  (focus)="textAreaAdjust($event)"
                                  [ngModelOptions]="{standalone: true}" maxlength="60"></textarea>
                          </div>
                          <div class="actions">
                              <button class="btn" (click)="openCreateTask(item.title)">
                                  <img src="./assets/images/icons/add-new-task-icon.svg" alt="">
                              </button>
                              <button class="btn" (click)="removeListItem(i, item.recommendationId)">
                                  <img src="./assets/images/icons/delete-icon.svg" alt="">
                              </button>
                          </div>
                      </div>
                  </div>
              </div>
              <div class="terms-control" [ngClass]='{"loading black": itemLoading}'>
                  <span class="drag-me">
                      <svg width="6" height="10.001" viewBox="0 0 6 10.001">
                          <path id="drag-drop-icon"
                              d="M4884.5,8787a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm4-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm4-4a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Zm-4,0a.5.5,0,0,1-.5-.5v-1a.5.5,0,0,1,.5-.5h1a.5.5,0,0,1,.5.5v1a.5.5,0,0,1-.5.5Z"
                              transform="translate(-4880 -8777)" fill="#aaa" />
                      </svg>
                  </span>
                  <span class="list-icon">
                      <svg width="14" height="14" viewBox="0 0 14 14">
                          <path id="listing-icon"
                              d="M3.809,6l-.33.329a.46.46,0,0,0,0,.651l2.5,2.5a.461.461,0,0,0,.651,0L12.99,3.125a.46.46,0,0,0,0-.651l-.33-.329a.461.461,0,0,0-.651,0L6.633,7.515a.461.461,0,0,1-.651,0L4.46,6A.461.461,0,0,0,3.809,6Zm9.248,1a.46.46,0,0,0-.459.425A5.606,5.606,0,1,1,7.008,1.4a5.524,5.524,0,0,1,1.3.146.462.462,0,0,0,.433-.122l.388-.388A.46.46,0,0,0,8.912.265,7.643,7.643,0,0,0,7.008,0,7,7,0,1,0,14,7.5a.461.461,0,0,0-.459-.5Z"
                              fill="#aaa" opacity="0.5" />
                      </svg>
                  </span>
                  <div>
                      <textarea placeholder="Add a recommendation..." class="form-control"
                          [(ngModel)]="listItem" (keyup)="textAreaAdjust($event)"
                          (focus)="textAreaAdjust($event)" (keydown.enter)="addListItem($event)"
                          [ngModelOptions]="{standalone: true}" maxlength="60"></textarea>
                  </div>
              </div>
          </div>

      </div> -->

      <!-- <div class="actions-container"
          *ngIf='item.votingClosed && tabs.length !== 3'> <!- -  && votingResult.votingSummaryList.length - ->
          <button class="btn btn-primary" (click)='addRecommendations()'>Add Recommendations</button>
      </div> -->
  </div>
</div>
